import styled from 'styled-components';
import { FiMoreVertical, FiMessageSquare } from 'react-icons/fi';
import toast from 'react-hot-toast'; // Importar toast
import Feedback from './Feedback';
import { supabase } from '../supabaseClient'; // Importar supabase

// --- Sidebar Header ---
const SidebarHeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 1rem;
  background-color: #202c33; /* Fundo header dark */
  border-bottom: 1px solid #263038; /* Borda sutil dark */
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

const MultimachineLogo = styled.img`
  height: 32px; /* Tamanho do logo Multimachine */
  width: auto;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  color: #aebac1; /* Cor ícones dark */
  font-size: 1.3rem;

  & > * {
    cursor: pointer;
  }
`;

// --- Search Bar ---
const SearchContainer = styled.div`
  padding: 0.5rem 1rem;
  background-color: #111b21; /* Fundo da busca dark */
  border-bottom: 1px solid #202c33; /* Borda sutil */
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: none;
  background-color: #202c33; /* Fundo input dark */
  color: #e9edef; /* Texto claro */
  font-size: 0.9rem;
  outline: none;

  &::placeholder {
    color: #8696a0; /* Placeholder cinza */
  }
`;

// --- Contact List ---
const ContactList = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  background-color: #111b21; /* Fundo lista dark */
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.8rem 1rem;
  cursor: pointer;
  background-color: ${({ active }) => (active ? '#2a3942' : '#111b21')}; /* Destaque dark */
  border-bottom: 1px solid #1a2229; /* Separador dark */

  &:hover {
    background-color: #202c33; /* Hover dark */
  }

  /* Ocultar em telas menores */
  @media (max-width: 768px) {
    display: none;
  }
`;

const ContactLogo = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 50%; /* Avatar redondo */
  object-fit: cover;
`;

const ContactDetails = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const ContactName = styled.span`
  font-weight: 500;
  color: #e9edef; /* Texto claro */
  font-size: 1rem;
`;

const LastMessage = styled.span`
  font-size: 0.85rem;
  color: #8696a0; /* Texto secundário claro */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Remover antigo container de feedback do final
/*
const SidebarFeedbackContainer = styled.div`
  padding: 1rem;
  border-top: 1px solid #2a3942;
  background-color: #182229;
  margin-top: auto;
`;
*/

// Novo container para a seção de feedback logo abaixo da busca
const FeedbackSection = styled.div`
  padding: 1rem; /* Espaçamento interno */
  background-color: #182229; /* Fundo ligeiramente diferente */
  border-bottom: 1px solid #202c33; /* Separador da lista de contatos */
`;


// Receber sessionId como prop
export default function Sidebar({ sessionId }) {
  // No futuro, aqui viria a lógica para buscar e listar múltiplos contatos
  // e selecionar o ativo. Por agora, só temos a Carla.

  // Função para salvar o feedback no Supabase
  const handleSidebarFeedback = async (fb) => {
    if (!fb || !fb.comment || !sessionId) {
      console.error("Feedback ou sessionId faltando.");
      toast.error('Erro ao enviar feedback. Tente novamente.'); // Substituir alert por toast.error
      return;
    }

    try {
      const { error } = await supabase
        .from('feedbacks') // Nome da tabela confirmado pela imagem
        .insert([
          { comment: fb.comment, session_id: sessionId } // Colunas confirmadas
        ]);

      if (error) {
        throw error;
      }

      console.log("Feedback salvo:", fb.comment, "Session:", sessionId);
      toast.success('Obrigado pelo feedback!'); // Substituir alert por toast.success
      // A limpeza do campo já ocorre no componente Feedback

    } catch (error) {
      console.error("Erro ao salvar feedback no Supabase:", error);
      toast.error('Houve um erro ao salvar seu feedback. Tente novamente.'); // Substituir alert por toast.error
    }
  };


  return (
    <>
      {/* Cabeçalho da Sidebar */}
      <SidebarHeaderContainer>
        <UserInfo>
          {/* Usar logo da Multimachine */}
          <MultimachineLogo src="https://framerusercontent.com/images/d4K8Gwk2OSmvCU0Rw9nUQq3OxU.svg?scale-down-to=512" alt="Logo Multimachine" />
          {/* Poderia ter o nome do usuário logado aqui */}
        </UserInfo>
        {/* HeaderActions removido */}
      </SidebarHeaderContainer>

      {/* Barra de Busca Removida */}

      {/* Nova Seção de Feedback */}
      <FeedbackSection>
        <Feedback onSubmit={handleSidebarFeedback} />
      </FeedbackSection>

      {/* Lista de Contatos */}
      <ContactList>
        {/* Item da Carla - Marcado como ativo */}
        <ContactItem active={true}>
          {/* Usar avatar genérico feminino */}
          <ContactLogo src="https://i.pravatar.cc/150?img=38" alt="Avatar Carla" />
          <ContactDetails>
            <ContactName>Carla Lendária</ContactName>
            <LastMessage>Agente IA Play Indoor</LastMessage>
          </ContactDetails>
        </ContactItem>
        {/* Outros contatos viriam aqui */}
      </ContactList>

      {/* Remover Feedback do final */}
    </>
  );
}
